import { Question } from "./question.model";

//Used to pass an answer to the note service
export class Answer {
	constructor(question: Question, answerKey: string) {
		this.question = new Question(question.questionId, question.category, question.answers);
		this.answerKey = answerKey;
	} 

	question: Question;
	answerKey: string;
}